/* THERAPY — policy pages: turn each <h2> section into a collapsible block.
 *
 * Shopify renders /policies/* as one flat .rte blob. Owner: "That's too much
 * information right now." So the page opens as a short list of section titles
 * and the reader expands only what they need.
 *
 * Progressive enhancement on purpose: with JS off the policy renders as plain
 * (smaller) prose, which is what a crawler or a payment-gateway website check
 * sees anyway — those read the HTML, not the rendered accordion. Nothing is
 * removed from the document, only wrapped.
 */
(function () {
  var rte = document.querySelector('.shopify-policy__body .rte');
  if (!rte) return;

  var heads = rte.querySelectorAll(':scope > h2');
  // A policy with no headings (the short ones) is already short enough — leave it.
  if (heads.length < 2) return;

  // Everything before the first h2 is the lead; it stays open.
  var intro = document.createElement('div');
  intro.className = 'tp-intro';
  var first = heads[0];
  while (rte.firstChild && rte.firstChild !== first) {
    intro.appendChild(rte.firstChild);
  }
  if (intro.childNodes.length) rte.insertBefore(intro, first);

  var made = [];

  [].forEach.call(heads, function (h2) {
    var details = document.createElement('details');
    details.className = 'tp-sec';

    var summary = document.createElement('summary');
    summary.textContent = h2.textContent.trim();

    var body = document.createElement('div');
    body.className = 'tp-body';

    // Collect siblings up to (not including) the next h2, BEFORE moving the
    // heading — otherwise nextSibling walks a tree we are mutating.
    var node = h2.nextSibling;
    var group = [];
    while (node && !(node.nodeType === 1 && node.tagName === 'H2')) {
      group.push(node);
      node = node.nextSibling;
    }

    rte.insertBefore(details, h2);
    details.appendChild(summary);
    details.appendChild(body);
    group.forEach(function (n) { body.appendChild(n); });
    h2.parentNode.removeChild(h2);

    made.push(details);
  });

  if (!made.length) return;

  // Expand / collapse all
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'tp-all';
  btn.textContent = 'Expand all';
  btn.setAttribute('aria-expanded', 'false');

  function sync() {
    var openCount = made.filter(function (d) { return d.open; }).length;
    var allOpen = openCount === made.length;
    btn.textContent = allOpen ? 'Collapse all' : 'Expand all';
    btn.setAttribute('aria-expanded', allOpen ? 'true' : 'false');
  }

  btn.addEventListener('click', function () {
    var allOpen = made.every(function (d) { return d.open; });
    made.forEach(function (d) { d.open = !allOpen; });
    sync();
  });

  made.forEach(function (d) { d.addEventListener('toggle', sync); });

  var anchor = rte.querySelector('.tp-intro') || rte.firstChild;
  if (anchor && anchor.nextSibling) {
    rte.insertBefore(btn, anchor.nextSibling);
  } else {
    rte.insertBefore(btn, rte.firstChild);
  }

  // Someone arriving on #section-3 (or using in-page search) should not land on
  // a closed section — open whatever the hash points at.
  function openFromHash() {
    if (!location.hash) return;
    var target = document.getElementById(location.hash.slice(1));
    if (!target) return;
    var sec = target.closest ? target.closest('.tp-sec') : null;
    if (sec) sec.open = true;
  }
  openFromHash();
  window.addEventListener('hashchange', openFromHash);

  // Ctrl/Cmd+F can't find text inside a collapsed <details> in some engines.
  // Opening everything before print at least makes the printed copy complete.
  window.addEventListener('beforeprint', function () {
    made.forEach(function (d) { d.open = true; });
    sync();
  });
})();
